import { VDBText } from "@components/atoms";
import useScreenOptionsHooks from "../../../../hooks/useScreenOptionsHooks";
import { getGroupName } from "../utils";
import { useTranslation } from "react-i18next";
import { useUserInfo } from "@redux/slices/userInfoSlice";

export const itemRightTextFunction = (
  itemRightText: string,
  selectedGroups: any,
  otherGroups: any
) => {
  const { theme, typography } = useScreenOptionsHooks();
  const { t } = useTranslation();
  const { getFeatureSettings, getVdbSetting } = useUserInfo();

  const showVDB =
    getVdbSetting() &&
    !getFeatureSettings()
      .move_vdb_public_group_at_last_in_search_group_sequence;

  const getGroupText = (groupKey: string) => {
    const selectedGroup = selectedGroups?.[groupKey];
    const otherGroup = otherGroups?.[groupKey];

    if (selectedGroup?.[0] === 0 && showVDB) {
      return t("searchGroup.state.vdb.text");
    }
    if (selectedGroup?.[0] !== 0 && selectedGroup?.length === 1) {
      return getGroupName(selectedGroup, otherGroup);
    }
    if (selectedGroup?.length === 1 && selectedGroup?.[0] === 0) {
      return t("searchGroup.state.vdb.text");
    }
    return t("searchGroup.state.multiple.text");
  };

  let text;
  switch (itemRightText) {
    case "diamond":
      text = getGroupText("diamond");
      break;
    case "lab_grown":
      text = getGroupText("lab_grown_diamond");
      break;
    case "gemstones":
      text = getGroupText("gemstone");
      break;
    case "jewelry":
      text = getGroupText("jewelry");
      break;
    default:
      text = itemRightText;
  }

  return (
    <VDBText type={typography["Body-R"]} color={theme["core-04"]}>
      {text}
    </VDBText>
  );
};
